import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import InputMask from 'react-input-mask';
import { useReCaptcha } from "next-recaptcha-v3";
import { fetchPostEmailSendSellYourVehicle } from "../../../services/api";

export default function SellYourVehicleForm() {
    const [formPost, setFormPost] = useState({ isLoading: false, isError: false, errorText: '', isSuccess: false });
    const { control, register, handleSubmit, formState: { errors }, setValue } = useForm();
    const { executeRecaptcha } = useReCaptcha();

    const onSubmit = async data => {
        const token = await executeRecaptcha("sellYourVehicleSubmit");
        setFormPost({ ...formPost, isLoading: true, isError: false, errorText: '', isSuccess: false });
        fetchPostEmailSendSellYourVehicle({
            mileage: data.txtVehicleMileage,
            value: data.txtValue,
            vehicle: data.txtVehicle,
            cellPhone: data.txtCellPhone,
            email: data.txtEmail,
            name: data.txtName,
            token
        })
            .then(res => {
                if (res) {
                    setValue('txtVehicle', '');
                    setValue('txtVehicleMileage', '');
                    setValue('txtName', '');
                    setValue('txtEmail', '');
                    setValue('txtCellPhone', '');
                    setValue('txtValue', '');
                    setFormPost({ ...formPost, isLoading: false, isSuccess: true });
                }
            })
            .catch(err => { setFormPost({ ...formPost, isLoading: false, isError: true, errorText: err.toString() }); });
    }
    return (
        <section className="contact-section ptb-40">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="car_listing_form">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="listing_info_box bg-white rounded">
                                    <h4 className="mb-3">Quer Vender Seu Veículo?</h4>
                                    <p className="mb-4">Informe os dados do seu veículo que faremos a melhor oferta do mercado.</p>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-9">
                                            <div className="input-field">
                                                <label>Veículo</label>
                                                <input type="text" placeholder="Ex.: Mercedes benz e 400 coupe 2017" {...register("txtVehicle", { required: true })} required={errors.txtVehicle} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Km Atual</label>
                                                <Controller
                                                    render={({ field: { value, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        placeholder={'Ex.: 30.000 km'}
                                                        suffix=' km'
                                                        required={errors.txtValue}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtVehicleMileage"
                                                    rules={{ required: true }}
                                                    control={control} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Nome Completo</label>
                                                <input type="text" placeholder="Ex.: Joaquim Santos Silva" {...register("txtName", { required: true })} required={errors.txtName} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="input-field">
                                                <label>Email</label>
                                                <input type="email" placeholder="Ex.: joaquimsantossilva@yahoo.com" {...register("txtEmail", { required: true, pattern: /^\S+@\S+$/i })} required={errors.txtEmail} />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                            <div className="input-field">
                                                <label>Celular</label>
                                                <InputMask type={'tel'} placeholder="Ex.: (11) 99999-9999" mask="(99) 99999-9999" maskChar=" " {...register("txtCellPhone", { required: true })} required={errors.txtCellPhone} />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="input-field">
                                                <label>Valor Desejado</label>
                                                <Controller
                                                    render={({ field: { value, name, onChange }, formState: { errors } }) => <NumericFormat
                                                        value={value}
                                                        name={name}
                                                        thousandSeparator="."
                                                        decimalSeparator=","
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        placeholder={'Ex.: 40.000,00'}
                                                        prefix='R$ '
                                                        required={errors.txtValue}
                                                        onValueChange={(v) => onChange(v.formattedValue)} />
                                                    }
                                                    name="txtValue"
                                                    rules={{ required: true }}
                                                    control={control} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    formPost.isError
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="error-badge bg-primary-light rounded d-block">{formPost.errorText}</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    formPost.isSuccess
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="success-badge bg-primary-success rounded d-block">Oferta enviada com sucesso, aguarde o retorno de nossa equipe!</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                <div className="form-btns d-flex align-items-center mt-40">
                                    <button
                                        type="submit"
                                        disabled={formPost.isLoading}
                                        className="btn btn-primary-contact">
                                        Enviar Dados<span className="ms-2"><i className="fa-solid fa-arrow-right"></i></span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}